<template>
  <div class="v2-behind-the-scenes">
    <h2 id="currently-on-ersties" class="mb-md-4">
      {{ t("Behind the Scenes") }}
    </h2>

    <div class="player">
      <app-frame>
        <player
          id="behind-the-scenes"
          :source="getBehindTheScenesUrlV2()"
          :poster="getFreeareaVideoPoster(`bts_poster.png`)"
          subtitles-de="BTS_Tinder_6479b73e11cb1.srt"
          ratio="16x9"
        />
      </app-frame>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getBehindTheScenesUrlV2, getFreeareaVideoPoster } from "@/utils/mediaHelper";
import AppFrame from "@/components/v2/app-frame/index.vue";
import Player from "@/components/player/index.vue";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "behind-the-scenes",
});

const { t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
